import * as React from 'react'

const IconDownload = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g fill='#00B2E3' fillRule='evenodd'>
      <path d='M19.5 7.12H17a1.5 1.5 0 1 0 0 3h1v9H7v-9h1a1.5 1.5 0 1 0 0-3H5.5A1.5 1.5 0 0 0 4 8.62v12a1.5 1.5 0 0 0 1.5 1.5h14a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5' />
      <path d='m14.317 11.824-.317.3V2.5a1.5 1.5 0 1 0-3 0v9.625l-.318-.301a1.496 1.496 0 0 0-2.12.057 1.5 1.5 0 0 0 .057 2.121l2.85 2.698a1.5 1.5 0 0 0 2.062 0l2.85-2.698a1.5 1.5 0 0 0-2.064-2.178' />
    </g>
  </svg>
)

export default IconDownload
